import { render, staticRenderFns } from "./FacturaCreate.vue?vue&type=template&id=60222868&scoped=true"
import script from "./FacturaCreate.vue?vue&type=script&lang=js"
export * from "./FacturaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60222868",
  null
  
)

export default component.exports